<div
	[ngClass]="
		!openedFromActionCenter ? 'filter-container' : 'action-center-filter-container'
	"
>
	<cmms-applied-filters-bar [activePage]="activePage" [currentEntity]="currentEntity" />
	<div class="d-flex">
		@for (filter of selectedFilters(); track filter.initialIndex) {
			<applied-filter-button
				[filter]="filter"
				[activePage]="activePage"
				[currentEntity]="currentEntity"
			/>
		}
	</div>
</div>
<div
	[ngClass]="
		!openedFromActionCenter ? 'entity-attachment-container' : 'action-center-container'
	"
	[class.fullscreen]="isFullscreen$ | async"
>
	@if (selections.selected.length) {
		<div class="chips-wrapper">
			<h3 class="section-title m-b-xs">
				{{ 'Selected ' + selections.selected.length }}
			</h3>
			<au-mat-chips
				[chips]="selections.selected"
				(deleteChip)="unselectEntityItemHandler($event)"
			></au-mat-chips>
		</div>
	}

	@if (!isLoadingResults) {
		@if (filterResultLoaded) {
			@if (tableData?.length) {
				<div class="scroll-x-auto nice-scroll colored-scroll-track visible-scroll">
					<au-table-layout
						[displayedColumns]="columns"
						[data]="tableData"
						[tableSelection]="true"
						[tableSelectedData]="selections"
						[openedFromActionCenter]="openedFromActionCenter"
						(bulkSelection)="bulkCheckboxSelectionHandler($event)"
						(rowCheckboxesSelect)="checkboxesSelectionHandler()"
						(rowCheckboxSelect)="checkboxSelectionHandler($event)"
					>
					</au-table-layout>
				</div>
			} @else {
				<au-empty-placeholder
					placeholderPath="./assets/img/no_users_found.svg"
					[width]="268"
					>{{ emptyPlaceholderText | translate }}</au-empty-placeholder
				>
			}
		} @else {
			<div class="search-loader-wrapper">
				<mat-spinner diameter="60"></mat-spinner>
			</div>
		}
	} @else {
		<div class="spinner-wrapper">
			<mat-spinner diameter="60"></mat-spinner>
		</div>
	}

	<au-paginator
		[nodes]="djangoPaginationData"
		(paginationEmit)="paginationUpdateHandler($event)"
	>
	</au-paginator>
</div>
